import * as React from "react";

export interface LabelledData {
  label: any;
  value: any;
}

export default function LabelledDataForm({ data }: { data: LabelledData[] }) {
  return (
    <div className="inline-form-editor">
      <div className="input-form">
        {data
          .filter((it) => it.value !== undefined)
          .map((it) => (
            <LabelledDataLine key={it.label} {...it} />
          ))}
      </div>
    </div>
  );
}

const LabelledDataLine = (props: LabelledData) => (
  <>
    <span className="input-name">{props.label}</span>
    <span className="input-value">{props.value}</span>
  </>
);
